import React from "react";
import { Button } from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  SettingOutlined,
  EditOutlined,
  CopyOutlined,
  DeleteOutlined,
  TeamOutlined,
  EyeOutlined,
  ExportOutlined,
  CloseOutlined,
  CheckOutlined,
  PhoneOutlined,
  ImportOutlined,
  ReadOutlined,
  ToolOutlined,
  DownloadOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { getLangList } from "@/lib/i18n";
// import { hasPermission } from "@/lib/PermissionUtil";
// import permissionKeys from "@/lib/permissionKeys";

interface props {
  permissionArray?: Array<string>,
  extraCondition?: boolean,
  attributeObject?: any,
  children?: any,
  iconName?: string,
  onClick?: any,
}

class ReButton extends React.Component<props, {}> {
  buttonT: any = getLangList("button");

  checkPermission = () => {
    // const { permissionArray = [] } = this.props;
    // let permissionPass = true;
    // for (let a = 0; a < permissionArray.length; a += 1) {
    //   if (!hasPermission(permissionKeys[permissionArray[a]])) {
    //     permissionPass = false;
    //     break;
    //   }
    // }
    // return permissionPass;
    return true;
  }

  getIcon = () => {
    const { iconName } = this.props;
    switch (iconName) {
      case 'search':
        return <SearchOutlined />;
      case 'plus':
        return <PlusOutlined />;
      case 'setting':
        return <SettingOutlined />;
      case 'edit':
        return <EditOutlined />;
      case 'copy':
        return <CopyOutlined />;
      case 'delete':
        return <DeleteOutlined />;
      case 'team':
        return <TeamOutlined />;
      case 'eye':
        return <EyeOutlined />;
      case 'export':
        return <ExportOutlined />;
      case 'close':
        return <CloseOutlined />;
      case 'check':
        return <CheckOutlined />;
      case 'phone':
        return <PhoneOutlined />;
      case 'import':
        return <ImportOutlined />;
      case 'book':
        return <ReadOutlined />;
      case 'tool':
        return <ToolOutlined />;
      case 'download':
        return <DownloadOutlined />;
      case 'reload':
        return <ReloadOutlined />;
      default:
        return null;
    }
  }

  render() {
    const { extraCondition = true, attributeObject = {}, children = null, onClick = () => { } } = this.props;
    return (
      this.checkPermission() && extraCondition && (
        <Button type="primary" icon={this.getIcon()} onClick={onClick} {...attributeObject}>
          {children}
        </Button>
      )
    );
  }
}

export default ReButton;